import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { SelectField, Option } from '@johnlewispartnership/wtr-ingredients/ingredients/Forms';
import { Controller } from 'react-hook-form';
import options, { ukOnlyOptions } from './iso-country-data';

const CountrySelect = ({
  ukOnlyAddress = false,
  setPlaceholders,
  errors,
  control,
  initialCountry = null,
}) => {
  const selectOptions = ukOnlyAddress ? ukOnlyOptions : options;

  return (
    <Controller
      id="country-field-controller"
      name="country"
      control={control}
      defaultValue={initialCountry}
      rules={{ required: 'Please select a country' }}
      render={renderProps => (
        <SelectField
          autoComplete="country"
          id="country"
          label="Country"
          onChange={event => {
            const { value } = event.target;

            renderProps.onChange(value);
            setPlaceholders(value);
          }}
          errorText={errors.country?.message}
        >
          {selectOptions.map(({ label, value }) => (
            <Option selected={initialCountry && initialCountry === value} key={value} value={value}>
              {label}
            </Option>
          ))}
        </SelectField>
      )}
    />
  );
};

CountrySelect.propTypes = {
  ukOnlyAddress: bool.isRequired,
  setPlaceholders: func.isRequired,
  errors: object.isRequired,
  control: func.isRequired,
  initialCountry: string,
};

export default CountrySelect;
